import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';
import type { AnalyticsRange } from '@entities/analytics';

interface RangeSwitcherProps {
  value: AnalyticsRange;
  onChange: (range: AnalyticsRange) => void;
}

export function RangeSwitcher({ value, onChange }: RangeSwitcherProps) {
  const { t } = useTranslation();
  const options = [
    { value: 'WEEK' as const, label: t('dashboard.range.week') },
    { value: 'MONTH' as const, label: t('dashboard.range.month') },
    { value: 'YEAR' as const, label: t('dashboard.range.year') },
  ];
  return (
    <Segmented
      options={options}
      value={value}
      onChange={(v) => onChange(v as AnalyticsRange)}
    />
  );
}
